const getNameByFirebaseStorage = (storagePath = '') => {
    if (typeof storagePath === 'string')
        return storagePath.slice(storagePath.lastIndexOf('/') + 1);
    else return '';
}

export default {
    getNameByFirebaseStorage,
};
